import { render, staticRenderFns } from "./UsuarioUpdatePerfil.vue?vue&type=template&id=38dabc20&"
import script from "./UsuarioUpdatePerfil.vue?vue&type=script&lang=js&"
export * from "./UsuarioUpdatePerfil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports